import axios from "axios";
import * as API_LINKS from '../../config/links.jsx'
import {toast} from 'react-toastify'

export const FETCH_TRIPL_WORK_ORDER_REQUEST_RESULT = 'FETCH_TRIPL_WORK_ORDER_REQUEST_RESULT'
export const RECEIVE_TRIPL_WORK_ORDER_REQUEST_RESULT = 'RECEIVE_TRIPL_WORK_ORDER_REQUEST_RESULT'
export const FAILED_TRIPL_WORK_ORDER_REQUEST_RESULT = 'FAILED_TRIPL_WORK_ORDER_REQUEST_RESULT'

export function fetchTriPLWorkOrderRequestResult(){    return (dispatch, getState) => {
        
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_TRIPL_WORK_ORDER_REQUEST_RESULT});
        axios({
            method: 'post',
            url: API_LINKS.TRIPL_WO_REQ_LIST_RESULT_URL,
            headers: {
                Authorization: auth
            },
            data: {
                // date: 
                // For Parameters
            }
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_TRIPL_WORK_ORDER_REQUEST_RESULT,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_TRIPL_WORK_ORDER_REQUEST_RESULT
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_TRIPL_WORK_ORDER_REQUEST_RESULT
                    })
                    return toast.error("Failed in fetching Work Orders List. Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_TRIPL_WORK_ORDER_REQUEST_RESULT
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_TRIPL_WORK_ORDER_REQUEST_RESULT
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_TRIPL_WORK_ORDER_REQUEST_RESULT
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_TRIPL_WORK_ORDER_REQUEST_RESULT
                })
                return toast.error('Something went wrong... Please try again later...')
            }

        })
    }
}